{
    "coordinates": [
        39.90580703887878,
        -74.85832237393018
    ],
    "tooltip": "Hornerstown",
    "title": "Hornerstown Formation",
    "country": "United States",
    "period": "Cretaceous",
    "alt": "TODO"
}
